module.exports = __webpack_public_path__ + "static/schaukel08-8ab2d3f19c3c49bf78ec98786e359340.jpg";